module.exports = __webpack_public_path__ + "db016cbf377c9cdf743a14d521daf7a6.pdf";